
import React, { useCallback, useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Calendar } from "react-multi-date-picker";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import { Controller, useForm } from "react-hook-form";
import moment from "moment";
import "react-tabs/style/react-tabs.css";
import CloseIcon from '@mui/icons-material/Close';

import Close_black from "../../../assets/close_black.svg";
import CalenderMark from "../../../assets/images/calender-mark.svg";
import scaleMark from "../../../assets/images/scale-mark.png";
import formIcon1 from "../../../assets/images/form-icon-1.svg";
import formIcon2 from "../../../assets/images/form-icon-2.svg";
import formIcon3 from "../../../assets/images/form-icon-3.svg";
import formIcon4 from "../../../assets/images/form-icon-4.svg";
import formIcon5 from "../../../assets/images/form-icon-5.svg";
import formIcon6 from "../../../assets/images/form-icon-6.svg";
import formIcon7 from "../../../assets/images/form-icon-7.svg";
import formIcon8 from "../../../assets/images/form-icon-8.svg";
import formIcon9 from "../../../assets/images/form-icon-9.svg";
import formIcon10 from "../../../assets/images/form-icon-10.svg";
import formIcon11 from "../../../assets/images/form-icon-11.svg";
import formIcon12 from "../../../assets/images/form-icon-12.svg";
import formIcon13 from "../../../assets/images/form-icon-13.svg";
import formIcon14 from "../../../assets/images/form-icon-14.svg";
import formIcon15 from "../../../assets/images/form-icon-15.svg";
import { FaInfoCircle } from "react-icons/fa"
import formIcon18 from "../../../assets/images/form-icon-18.svg";
import formIcon19 from "../../../assets/images/form-icon-19.svg";
import formIcon20 from "../../../assets/images/form-icon-20.svg";
import formIcon21 from "../../../assets/images/form-icon-21.svg";
import formIcon22 from "../../../assets/images/form-icon-22.svg";
import formIcon23 from "../../../assets/images/form-icon-23.svg";
import formIcon24 from "../../../assets/images/form-icon-24.svg";
import formIcon25 from "../../../assets/images/form-icon-25.svg";
import TooltipIcon from "../../../assets/images/tool-tip-icon.svg";
import Select from "react-select";
// import { colourOptions } from '../data';
import $ from "jquery";
import { useToast } from "../../../toast";
import { countJSON, feetJSON, inchesJSON } from "../../../constants";
import {
    addPersonalDetail,
    getAdjectives,
    getAwards,
    getBirthmarkBodyParts,
    getBodyParts,
    getBodyTypes,
    getBrand,
    getClothingStyles,
    getEyeColors,
    getFoodPreferences,
    getHairColors,
    getHairLength,
    getHairType,
    getLanguage,
    getOtherSkills,
    getPersonalDetail,
    getPhoneBrands,
    getPiercingBodyParts,
    getSkinColors,
    getStrengths,
    getTattoosBodyParts,
    getVideoShootingTypes,
    getVoiceTypes,
    updatePersonalDetail,
} from "../../../services";
import {
    GET_PERSONAL_DETAIL,
    REGISTER_DETAILS,
} from "../../../redux/action_type";
import { onJustReducerUpdate } from "../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import _ from 'lodash';
import { MuiChipsInput } from 'mui-chips-input'
import { useLocation } from "react-router-dom";

function CreatorForm() {
    const profileDetails = useSelector((state) => state?.profileDetails)
    const [selectedTabs, setSelectedTabs] = useState(0);
    const toast = useToast();
    const location = useLocation()
    const [agePicker, setAgePicker] = useState("");
    const [dropDownValues, setDropDownValues] = useState({});
    const [basicSubmit, setBasicSubmit] = useState({});
    const [physicalSubmit, setPhysicalSubmit] = useState({});
    const [personalitySubmit, setPersonalitySubmit] = useState({});
    const [submitValueThree, setSubmitValueThree] = useState(false);
    const [submitValueOne, setSubmitValueOne] = useState(false);
    const [submitValueTwo, setSubmitValueTwo] = useState(false);
    const [isFormUpdate, setIsFormUpdate] = useState(false);
    const dispatch = useDispatch();
    const personalData = useSelector((state) => state?.personalDetail)
    const [tabTwoDataRestrict, setTwoTabDataRestrict] = useState(false)
    const [tabThreeDataRestrict, setThreeTabDataRestrict] = useState(false)
    const isPathName = window.location.pathname

    const {
        register: register,
        handleSubmit,
        control,
        setValue,
        getValues,
        watch,
        reset,
        formState: { errors, isDirty },
    } = useForm({ resolver: yupResolver() });
    const basicDataFormData = getValues()
    const basicDataWatch = watch()
    watch("other_languages", false);
    const {
        register: register2,
        handleSubmit: handleSubmit2,
        control: control2,
        setValue: setValueTwo,
        getValues: getValuesTwo,
        watch: watchTwo,
        reset: resetTwo,
        formState: { errors: errors2, isDirty: isDirtyTwo },
    } = useForm({ resolver: yupResolver() });
    const physicalFormData = getValuesTwo()
    const physicalWatch = watchTwo()
    watchTwo("other_hair_color", false);
    watchTwo("other_hair_length", false);
    watchTwo("other_piercing", false);
    watchTwo("other_birthmark_moles", false);
    watchTwo("other_tattoos", false);
    const {
        register: register3,
        handleSubmit: handleSubmit3,
        control: control3,
        setValue: setvalueThree,
        getValues: getValuesThree,
        watch: watchThree,
        reset: resetThree,
        formState: { errors: errors3, isDirty: isDirtyThree },
    } = useForm({ resolver: yupResolver() });
    const personalFormData = getValuesThree()
    const personalWatch = watchThree()
    watchTwo("other_adjectives", false);
    watchTwo("other_phone_brand", false);
    const customStyles = {
        menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
        menu: (provided) => ({ ...provided, zIndex: 9999 }),
    };
    useEffect(() => {
        if (parseInt(getValuesTwo("count_tattoo")?.value) < (physicalFormData?.tattoos?.some(a => a.value === "other") ? physicalFormData?.tattoos?.length - 1 : physicalFormData?.tattoos?.length) + physicalFormData?.other_tattoos?.length) {
            setValueTwo("tattoos", [])
            setValueTwo("other_tattoos", [])
        }
        if (parseInt(getValuesTwo("count_piercing")?.value) < (physicalFormData?.piercing?.some(a => a.value === "other") ? physicalFormData?.piercing?.length - 1 : physicalFormData?.piercing?.length) + physicalFormData?.other_piercing?.length) {
            setValueTwo("piercing", [])
            setValueTwo("other_piercing", [])
        }
        if (parseInt(getValuesTwo("count_mole")?.value) < (physicalFormData?.birthmark_moles?.some(a => a.value === "other") ? physicalFormData?.birthmark_moles?.length - 1 : physicalFormData?.birthmark_moles?.length) + physicalFormData?.other_birthmark_moles?.length) {
            setValueTwo("birthmark_moles", [])
            setValueTwo("other_birthmark_moles", [])
        }
        if (!basicDataFormData?.languages?.some(a => a.value === "other")) {
            setValue("other_languages", [])
        }
        if (physicalFormData?.hair_color?.text === "Other" === false) {
            setValueTwo("other_hair_color", [])
        }
        if (physicalFormData?.hair_length?.text === "Other" === false) {
            setValueTwo("other_hair_length", [])
        }
        if (!physicalFormData?.tattoos?.some(a => a.value === "other")) {
            setValueTwo("other_tattoos", [])
        }
        if (!physicalFormData?.piercing?.some(a => a.value === "other")) {
            setValueTwo("other_piercing", [])
        }
        if (!physicalFormData?.birthmark_moles?.some(a => a.value === "other")) {
            setValueTwo("other_birthmark_moles", [])
        }
        if (!personalFormData?.adjectives?.some(a => a.value === "other")) {
            setvalueThree("other_adjectives", [])
        }
        if (!personalFormData?.phone_brand?.some(a => a.value === "other")) {
            setvalueThree("other_phone_brand", [])
        }
    }, [getValuesTwo("count_tattoo"), getValuesTwo("count_mole"), getValuesTwo("count_piercing"), getValues("languages"), getValuesTwo("hair_color"), getValuesTwo("hair_length"), getValuesTwo("tattoos"), getValuesTwo("piercing"), getValuesTwo("birthmark_moles"), getValuesThree("adjectives"), getValuesThree("phone_brand")])
    const initialValue = () => {
        if (!_.isEmpty(personalData) && !_.isEmpty(dropDownValues) && profileDetails.personal_detail) {
            const { personality_traits, basic_info, physical_attributes } = personalData
            if (_.isEmpty(personality_traits) || _.isEmpty(physical_attributes) || _.isEmpty(basic_info)) {
                return
            }
            setValue("height_inch", inchesJSON.find(a => a.value === basic_info.height_inch))
            setValue("height_feet", feetJSON.find(a => a.value === basic_info.height_feet))
            setValue("weight", basic_info?.weight)
            const temp = basic_info?.dob?.split("-")
            if (temp) {
                setAgePicker(new Date(`${temp[1]}-${temp[0]}-${temp[2]}`))
                setValue("dob", new Date(`${temp[1]}-${temp[0]}-${temp[2]}`))
            }
            setValue("languages", dropDownValues?.language?.filter(a => basic_info?.languages_str?.includes(a.text)))
            setValue("other_languages", basic_info?.other_languages_str?.split(",") || "")
            setValueTwo("other_hair_length", physical_attributes?.other_hair_length_str?.split(",") || [])
            setValueTwo("other_hair_color", physical_attributes?.other_hair_color_str?.split(",") || [])
            setValueTwo("other_piercing", physical_attributes?.other_piercing?.places_str?.split(",") || [])
            setValueTwo("other_birthmark_moles", physical_attributes?.other_birthmark_moles?.places_str?.split(",") || [])
            setValueTwo("other_tattoos", physical_attributes?.other_tattoos_str?.split(",") || [])
            setValueTwo("hair_type", physical_attributes?.hair_type)
            setValueTwo("hair_length", dropDownValues?.hair_length?.find(a => a.text === physical_attributes?.hair_length_str))
            setValueTwo("hair_color", dropDownValues?.hairColors?.find(a => a.text === physical_attributes?.hair_color_str))
            setValueTwo("voice_type", dropDownValues?.voiceTypes?.find(a => a.text === physical_attributes?.voice_type))
            setValueTwo("strength", dropDownValues?.strengths?.find(a => a.text === physical_attributes?.strength))
            setValueTwo("body_type", dropDownValues?.bodyTypes?.find(a => a.text === physical_attributes?.body_type))
            setValueTwo("eye_color", dropDownValues.eyeColors?.find(a => a.text === physical_attributes?.eye_color))
            setValueTwo("skin_color", dropDownValues.skinColors?.find(a => a.text === physical_attributes?.skin_color))
            setValueTwo("count_tattoo", countJSON?.find(a => a.value === physical_attributes?.tattoos?.total_count?.toString()))
            setValueTwo("count_mole", countJSON?.find(a => a.value === physical_attributes?.birthmark_moles?.total_count?.toString()))
            setValueTwo("count_piercing", countJSON?.find(a => a.value === physical_attributes?.piercing?.total_count?.toString()))
            setValueTwo("tattoos", dropDownValues?.tattoosBodyParts?.filter(a => physical_attributes?.tattoos?.places_str
                ?.includes(a.text)))
            setValueTwo("piercing", dropDownValues?.piercingBodyParts?.filter(a => physical_attributes?.piercing?.places_str
                ?.includes(a.text)))
            setValueTwo("birthmark_moles", dropDownValues?.birthmarkBodyParts?.filter(a => physical_attributes?.birthmark_moles?.places_str
                ?.includes(a.text)))
            setvalueThree("adjectives", dropDownValues?.adjectives?.filter(a => personality_traits?.adjectives_str?.includes(a.text)))
            setvalueThree("associated_brands", personality_traits?.associated_brands || [])
            setvalueThree("other_adjectives", personality_traits?.other_adjectives || [])
            setvalueThree("other_phone_brand", personality_traits?.other_phone_brand || [])
            setvalueThree("other_skills", personality_traits?.other_skills || [])
            setvalueThree("awards", personality_traits?.awards || [])
            setvalueThree("phone_brand", dropDownValues?.phoneBrands?.filter(a => personality_traits?.phone_brand_str?.includes(a.text)))
            setvalueThree("preferred_clothings", dropDownValues?.clothingStyles?.filter(a => personality_traits?.preferred_clothings?.includes(a.text)))
            setvalueThree("shooting_mode", dropDownValues?.videoShootingTypes?.filter(a => personality_traits?.shooting_mode?.includes(a.text)))
            setvalueThree("food_preferences", dropDownValues?.foodPreferences?.find(a => a.text === personality_traits?.food_preferences))
        }
    }
    const resetTabs = () => {
        reset();
        resetTwo();
        resetThree();
        initialValue()
        setSelectedTabs(0);
    }

    useEffect(() => {
        $('#creator-pop-new').on('shown.bs.modal', function (e) {
            setSelectedTabs(0);
            onGetDropDownValues();
        })
    }, [])

    useEffect(() => {
        resetTabs()
    }, [personalData, profileDetails])

    const onGetDropDownValues = async () => {
        let authData = localStorage.getItem(REGISTER_DETAILS);
        authData = JSON.parse(authData);
        if (!authData) {
            return;
        }
        if (selectedTabs === 0) {
            const language = await getLanguage().catch((e) => console.log("err", e));
            setDropDownValues((prevState) => ({
                ...prevState, language: language?.data || []
            }))
        }
        const personalDetail = await getPersonalDetail().catch((e) => console.log("err", e));
        dispatch(onJustReducerUpdate(personalDetail?.data, GET_PERSONAL_DETAIL))
    };

    useEffect(() => {
        onGetTabsTwoValue()
        onGetTabsThreeValue()
    }, [selectedTabs])

    const onGetTabsTwoValue = async () => {
        if (selectedTabs === 1 && !tabTwoDataRestrict) {
            const hairColors = await getHairColors().catch((e) => console.log("err", e));
            const hair_length = await getHairLength().catch((e) => console.log("err", e));
            const hairType = await getHairType().catch((e) => console.log("err", e));
            const skinColors = await getSkinColors().catch((e) => console.log("err", e));
            const eyeColors = await getEyeColors().catch((e) => console.log("err", e));
            const strengths = await getStrengths().catch((e) => console.log("err", e));
            const voiceTypes = await getVoiceTypes().catch((e) => console.log("err", e));
            const bodyTypes = await getBodyTypes().catch((e) => console.log("err", e));
            const tattoosBodyParts = await getTattoosBodyParts().catch((e) => console.log("err", e));
            const birthmarkBodyParts = await getBirthmarkBodyParts().catch((e) => console.log("err", e));
            const piercingBodyParts = await getPiercingBodyParts().catch((e) => console.log("err", e));
            setDropDownValues((prevState) => ({
                ...prevState,
                hairColors: hairColors?.data || [],
                hair_length: hair_length?.data || [],
                hairType: hairType?.data || [],
                skinColors: skinColors?.data || [],
                eyeColors: eyeColors?.data || [],
                strengths: strengths?.data || [],
                voiceTypes: voiceTypes?.data || [],
                bodyTypes: bodyTypes?.data || [],
                tattoosBodyParts: tattoosBodyParts?.data || [],
                birthmarkBodyParts: birthmarkBodyParts?.data || [],
                piercingBodyParts: piercingBodyParts?.data || [],
            }))
            setTwoTabDataRestrict(true)
        }
    }

    useEffect(() => {
        if (selectedTabs === 1 && tabTwoDataRestrict && !isDirtyTwo) {
            setValueTwo("other_hair_length", personalData?.physical_attributes?.other_hair_length_str?.split(",") || [])
            setValueTwo("other_hair_color", personalData?.physical_attributes?.other_hair_color_str?.split(",") || [])
            setValueTwo("other_piercing", personalData?.physical_attributes?.other_piercing?.places_str?.split(",") || [])
            setValueTwo("other_birthmark_moles", personalData?.physical_attributes?.other_birthmark_moles?.places_str?.split(",") || [])
            setValueTwo("other_tattoos", personalData?.physical_attributes?.other_tattoos_str?.split(",") || "")
            setValueTwo("hair_type", personalData?.physical_attributes?.hair_type)
            setValueTwo("hair_length", dropDownValues?.hair_length?.find(a => a.text === personalData?.physical_attributes?.hair_length_str))
            setValueTwo("hair_color", dropDownValues?.hairColors?.find(a => a.text === personalData?.physical_attributes?.hair_color_str))
            setValueTwo("voice_type", dropDownValues?.voiceTypes?.find(a => a.text === personalData?.physical_attributes?.voice_type))
            setValueTwo("strength", dropDownValues?.strengths?.find(a => a.text === personalData?.physical_attributes?.strength))
            setValueTwo("body_type", dropDownValues?.bodyTypes?.find(a => a.text === personalData?.physical_attributes?.body_type))
            setValueTwo("eye_color", dropDownValues.eyeColors?.find(a => a.text === personalData?.physical_attributes?.eye_color))
            setValueTwo("skin_color", dropDownValues.skinColors?.find(a => a.text === personalData?.physical_attributes?.skin_color))
            setValueTwo("count_tattoo", countJSON?.find(a => a.value === personalData?.physical_attributes?.tattoos?.total_count?.toString()))
            setValueTwo("count_mole", countJSON?.find(a => a.value === personalData?.physical_attributes?.birthmark_moles?.total_count?.toString()))
            setValueTwo("count_piercing", countJSON?.find(a => a.value === personalData?.physical_attributes?.piercing?.total_count?.toString()))
            setValueTwo("tattoos", dropDownValues?.tattoosBodyParts?.filter(a => personalData?.physical_attributes?.tattoos?.places_str
                ?.includes(a.text)))
            setValueTwo("piercing", dropDownValues?.piercingBodyParts?.filter(a => personalData?.physical_attributes?.piercing?.places_str
                ?.includes(a.text)))
            setValueTwo("birthmark_moles", dropDownValues?.birthmarkBodyParts?.filter(a => personalData?.physical_attributes?.birthmark_moles?.places_str
                ?.includes(a.text)))
        }
    }, [dropDownValues, selectedTabs, personalData, tabTwoDataRestrict])

    const onGetTabsThreeValue = async () => {
        if (selectedTabs === 2 && !tabThreeDataRestrict) {
            const adjectives = await getAdjectives().catch((e) => console.log("err", e));
            const phoneBrands = await getPhoneBrands().catch((e) => console.log("err", e));
            const videoShootingTypes = await getVideoShootingTypes().catch((e) => console.log("err", e));
            const clothingStyles = await getClothingStyles().catch((e) => console.log("err", e));
            const foodPreferences = await getFoodPreferences().catch((e) => console.log("err", e));
            const bodyParts = await getBodyParts().catch((e) => console.log("err", e));
            const brand = await getBrand().catch((e) => console.log("err", e));
            const otherSkills = await getOtherSkills().catch((e) => console.log("err", e));
            const awards = await getAwards().catch((e) => console.log("err", e));

            setDropDownValues((prevState) => ({
                ...prevState,
                adjectives: adjectives?.data || [],
                phoneBrands: phoneBrands?.data || [],
                videoShootingTypes: videoShootingTypes?.data || [],
                clothingStyles: clothingStyles?.data || [],
                foodPreferences: foodPreferences?.data || [],
                bodyParts: bodyParts?.data || [],
                brand: brand?.data || [],
                otherSkills: otherSkills?.data || [],
                awards: awards?.data || [],

            }))
            setThreeTabDataRestrict(true)
        }
    }

    useEffect(() => {
        if (selectedTabs === 2 && tabThreeDataRestrict && !isDirtyThree) {
            setvalueThree("adjectives", dropDownValues?.adjectives?.filter(a => personalData?.personality_traits?.adjectives_str?.includes(a.text)))
            setvalueThree("associated_brands", personalData?.personality_traits?.associated_brands || [])
            setvalueThree("other_adjectives", personalData?.personality_traits?.other_adjectives || [])
            setvalueThree("other_phone_brand", personalData?.personality_traits?.other_phone_brand || [])
            setvalueThree("other_skills", personalData?.personality_traits?.other_skills || [])
            setvalueThree("awards", personalData?.personality_traits?.awards || [])
            setvalueThree("phone_brand", dropDownValues?.phoneBrands?.filter(a => personalData?.personality_traits?.phone_brand_str?.includes(a.text)))
            setvalueThree("preferred_clothings", dropDownValues?.clothingStyles?.filter(a => personalData?.personality_traits?.preferred_clothings?.includes(a.text)))
            setvalueThree("shooting_mode", dropDownValues?.videoShootingTypes?.filter(a => personalData?.personality_traits?.shooting_mode?.includes(a.text)))
            setvalueThree("food_preferences", dropDownValues?.foodPreferences?.find(a => a.text === personalData?.personality_traits?.food_preferences))
        }
    }, [dropDownValues, selectedTabs, personalData])

    const weekDays = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];
    const onDatePick = () => {
        $("#open-date-picker").modal("hide");
    };

    useEffect(() => {
        if (isPathName === "/creator-landing") {
        function confirmNavigation(event) {
            if (isDirty || isDirtyTwo || isDirtyThree) {
                event.preventDefault();
                event.returnValue = "";
            } else {
                return null;
            }
        }
        window.addEventListener("beforeunload", confirmNavigation);
        return () => window.removeEventListener("beforeunload", confirmNavigation);
    }
    }, [isDirty, isDirtyTwo, isDirtyThree]);

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode === 27 && (isDirty || isDirtyThree || isDirtyTwo)) {
                onSaveDetails()
            }
        };
        window.addEventListener("keydown", handleEsc);
    }, [(isDirty, isDirtyThree, isDirtyTwo)]);

    useEffect(() => {
        if (agePicker) {
            const dob = moment(agePicker).format("DD-MM-YYYY");
            setValue("dob", dob);
        }
    }, [agePicker]);

    const resetForm = () => {
        if (isDirty || isDirtyThree || isDirtyTwo) {
            onSaveDetails()
        } else {
            $("#creator-pop-new").modal("hide");
        }
        // setSelectedTabs(0);
        $("#creator-pop-new .modal-body").scrollTop(0);
    };
    useEffect(() => {
        if (
            Object.keys(errors3)?.length > 0 === false &&
            submitValueThree === true
        ) {
            onSaveDetails()
            setSubmitValueThree(false);
        }
    }, [errors3, submitValueThree]);

    useEffect(() => {
        if (_.isEmpty(errors) && _.isEmpty(errors2) && _.isEmpty(errors3) && isFormUpdate === true) {
            onSaveDetails()
            setIsFormUpdate(false)

        }
    }, [errors, errors2, errors3, isFormUpdate]);
    const onSaveDetails = () => {
        if (isDirty && !isDirtyTwo && !isDirtyThree || !isDirty && !isDirtyTwo && !isDirtyThree) {
            var allSubmit = {
                ...basicDataFormData,
                weight: basicDataFormData?.weight?.toString(),
                languages: basicDataFormData?.languages?.map((e) => e.text)?.toString(),
                other_languages: basicDataFormData?.other_languages?.toString(),
                height_feet: basicDataFormData?.height_feet?.value?.toString(),
                height_inch: basicDataFormData?.height_inch?.value?.toString(),
                body_type: personalData?.physical_attributes?.body_type,
                eye_color: personalData?.physical_attributes?.eye_color,
                hair_color: personalData?.physical_attributes?.hair_color_str,
                other_hair_color: personalData?.physical_attributes?.other_hair_color_str || "",
                other_birthmark_moles: personalData?.physical_attributes?.other_birthmark_moles_str || "",
                hair_type: personalData?.physical_attributes?.hair_type,
                hair_length: personalData?.physical_attributes?.hair_length_str,
                other_birthmark_moles_str: personalData?.physical_attributes?.other_birthmark_moles_str || "",
                other_hair_length: personalData?.physical_attributes?.other_hair_length_str || "",
                other_piercing: personalData?.physical_attributes?.other_piercing_str || "",
                piercing: personalData?.physical_attributes?.piercing_str,
                skin_color: personalData?.physical_attributes?.skin_color,
                strength: personalData?.physical_attributes?.strength,
                tattoos: personalData?.physical_attributes?.tattoos_str,
                other_tattoos: personalData?.physical_attributes?.other_tattoos_str || "",
                voice_type: personalData?.physical_attributes?.voice_type,
                birthmark_moles: personalData?.physical_attributes?.birthmark_moles_str,
                awards: personalData?.personality_traits?.awards_str,
                other_skills: personalData?.personality_traits?.other_skills_str,
                adjectives: personalData?.personality_traits?.adjectives_str,
                associated_brands: personalData?.personality_traits?.associated_brands?.toString(),
                food_preferences: personalData?.personality_traits?.food_preferences,
                other_adjectives: personalData?.personality_traits?.other_adjectives_str || "",
                other_phone_brand: personalData?.personality_traits?.other_phone_brand_str || "",
                phone_brand: personalData?.personality_traits?.phone_brand_str,
                preferred_clothings: personalData?.personality_traits?.preferred_clothings_str,
                shooting_mode: personalData?.personality_traits?.shooting_mode,
            }
        }
        else if (!isDirty && isDirtyTwo && !isDirtyThree) {
            var allSubmit = {
                ...basicDataFormData,
                ...physicalFormData,
                weight: basicDataFormData?.weight?.toString(),
                languages: basicDataFormData?.languages?.map((e) => e.text)?.toString(),
                other_languages: basicDataFormData?.other_languages?.toString(),
                height_feet: basicDataFormData?.height_feet?.value?.toString(),
                height_inch: basicDataFormData?.height_inch?.value?.toString(),
                strength: physicalFormData?.strength?.text,
                eye_color: physicalFormData?.eye_color?.text,
                body_type: physicalFormData?.body_type?.text,
                hair_color: physicalFormData?.hair_color?.text,
                hair_type: physicalFormData?.hair_type,
                hair_length: physicalFormData?.hair_length?.text,
                other_hair_length: physicalFormData?.other_hair_length?.toString(),
                other_hair_color: physicalFormData?.other_hair_color?.toString(),
                other_piercing: physicalFormData?.other_piercing?.toString(),
                other_birthmark_moles: physicalFormData?.other_birthmark_moles?.toString(),
                other_tattoos: physicalFormData?.other_tattoos?.toString(),
                piercing: `${physicalFormData?.count_piercing?.value || ""}:${physicalFormData?.piercing
                    ?.map((e) => e.text)
                    .toString()}`,
                skin_color: physicalFormData?.skin_color?.text,
                tattoos: `${physicalFormData?.count_tattoo?.value || ""}:${physicalFormData?.tattoos
                    ?.map((e) => e.text)
                    .toString()}`,
                voice_type: physicalFormData?.voice_type?.text,
                birthmark_moles: `${physicalFormData?.count_mole?.value
                    || ""}:${physicalFormData?.birthmark_moles?.map((e) => e.text)?.toString()}`,

                awards: personalData?.personality_traits?.awards_str,
                other_skills: personalData?.personality_traits?.other_skills_str,
                adjectives: personalData?.personality_traits?.adjectives_str,
                associated_brands: personalData?.personality_traits?.associated_brands?.toString(),
                food_preferences: personalData?.personality_traits?.food_preferences,
                other_adjectives: personalData?.personality_traits?.other_adjectives_str || "",
                other_phone_brand: personalData?.personality_traits?.other_phone_brand_str || "",
                phone_brand: personalData?.personality_traits?.phone_brand_str,
                preferred_clothings: personalData?.personality_traits?.preferred_clothings_str,
                shooting_mode: personalData?.personality_traits?.shooting_mode,
            }
        } else if (!isDirty && !isDirtyTwo && isDirtyThree) {
            var allSubmit = {
                ...basicDataFormData,
                ...personalFormData,
                weight: basicDataFormData?.weight?.toString(),
                languages: basicDataFormData?.languages?.map((e) => e.text)?.toString(),
                other_languages: basicDataFormData?.other_languages?.toString(),
                height_feet: basicDataFormData?.height_feet?.value?.toString(),
                height_inch: basicDataFormData?.height_inch?.value?.toString(),
                body_type: personalData?.physical_attributes?.body_type,
                eye_color: personalData?.physical_attributes?.eye_color,
                hair_type: personalData?.physical_attributes?.hair_type,
                hair_color: personalData?.physical_attributes?.hair_color_str || "",
                hair_length: personalData?.physical_attributes?.hair_length_str || "",
                other_birthmark_moles_str: personalData?.physical_attributes?.other_birthmark_moles_str || "",
                other_hair_length: personalData?.physical_attributes?.other_hair_length_str || "",
                other_piercing: personalData?.physical_attributes?.other_piercing_str || "",
                other_hair_color: personalData?.physical_attributes?.other_hair_color_str || "",
                other_birthmark_moles: personalData?.physical_attributes?.other_birthmark_moles_str || "",
                piercing: personalData?.physical_attributes?.piercing_str,
                skin_color: personalData?.physical_attributes?.skin_color,
                strength: personalData?.physical_attributes?.strength,
                tattoos: personalData?.physical_attributes?.tattoos_str,
                other_tattoos: personalData?.physical_attributes?.other_tattoos_str || "",
                voice_type: personalData?.physical_attributes?.voice_type,
                birthmark_moles: personalData?.physical_attributes?.birthmark_moles_str,
                adjectives: personalFormData?.adjectives?.map((e) => e.text)?.toString(),
                associated_brands: personalFormData?.associated_brands?.toString(),
                preferred_clothings: personalFormData?.preferred_clothings?.map((e) => e.text)?.toString(),
                awards: personalFormData?.awards?.toString(),
                other_skills: personalFormData?.other_skills?.toString(),
                food_preferences: personalFormData?.food_preferences?.text,
                phone_brand: personalFormData?.phone_brand?.map((e) => e.text)?.toString(),
                shooting_mode: personalFormData?.shooting_mode?.map((e) => e.text)?.toString(),
                other_adjectives: personalFormData?.other_adjectives?.toString(),
                other_phone_brand: personalFormData?.other_phone_brand?.toString(),
            }
        }
        else {
            var allSubmit = {
                ...personalData?.basic_info,
                ...personalData?.personality_traits,
                ...personalData?.physical_attributes,
                weight: basicDataFormData?.weight?.toString(),
                languages: basicDataFormData?.languages?.map((e) => e.text)?.toString(),
                other_languages: basicDataFormData?.other_languages?.toString(),
                height_feet: basicDataFormData?.height_feet?.value?.toString(),
                height_inch: basicDataFormData?.height_inch?.value?.toString(),
                strength: physicalFormData?.strength?.text,
                eye_color: physicalFormData?.eye_color?.text,
                body_type: physicalFormData?.body_type?.text,
                hair_color: physicalFormData?.hair_color?.text,
                hair_type: physicalFormData?.hair_type,
                hair_length: physicalFormData?.hair_length?.text,
                other_hair_length: physicalFormData?.other_hair_length?.toString(),
                other_hair_color: physicalFormData?.other_hair_color?.toString(),
                other_piercing: physicalFormData?.other_piercing?.toString(),
                other_birthmark_moles: physicalFormData?.other_birthmark_moles?.toString(),
                other_tattoos: physicalFormData?.other_tattoos?.toString(),
                piercing: `${physicalFormData?.count_piercing?.value || ""}:${physicalFormData?.piercing
                    ?.map((e) => e.text)
                    .toString()}`,
                skin_color: physicalFormData?.skin_color?.text,
                tattoos: `${physicalFormData?.count_tattoo?.value || ""}:${physicalFormData?.tattoos
                    ?.map((e) => e.text)
                    .toString()}`,
                voice_type: physicalFormData?.voice_type?.text,
                birthmark_moles: `${physicalFormData?.count_mole?.value
                    || ""}:${physicalFormData?.birthmark_moles?.map((e) => e.text)?.toString()}`,
                adjectives: personalFormData?.adjectives?.map((e) => e.text)?.toString(),
                associated_brands: personalFormData?.associated_brands?.toString(),
                preferred_clothings: personalFormData?.preferred_clothings?.map((e) => e.text)?.toString(),
                awards: personalFormData?.awards?.toString(),
                other_skills: personalFormData?.other_skills?.toString(),
                food_preferences: personalFormData?.food_preferences?.text,
                phone_brand: personalFormData?.phone_brand?.map((e) => e.text)?.toString(),
                shooting_mode: personalFormData?.shooting_mode?.map((e) => e.text)?.toString(),
                other_adjectives: personalFormData?.other_adjectives?.toString(),
                other_phone_brand: personalFormData?.other_phone_brand?.toString(),
            };
        }
        delete allSubmit.count_mole;
        delete allSubmit.count_tattoo;
        delete allSubmit.count_piercing;
        delete allSubmit.key;
        if (profileDetails.personal_detail) {
            updatePersonalDetail(allSubmit).then(async (res) => {
                toast.buttomOpen("Information saved successfully");
                reset()
                resetTwo()
                resetThree()
                onGetDropDownValues()
                $("#creator-pop-new").modal("hide");
                setSelectedTabs(0);
                let personalDetail = await getPersonalDetail().catch((e) => console.log("err", e));
                dispatch(onJustReducerUpdate(personalDetail?.data, GET_PERSONAL_DETAIL))
            }).catch(err => console.log("err", err))
            return
        }
        addPersonalDetail(allSubmit).then(async (res) => {
            toast.buttomOpen("Information saved successfully");
            $("#creator-pop-new").modal("hide");
            setSelectedTabs(0);
            let personalDetail = await getPersonalDetail().catch((e) => console.log("err", e));
            dispatch(onJustReducerUpdate(personalDetail?.data, GET_PERSONAL_DETAIL))
        }).catch(err => console.log("err", err))
    };

    return (
        <>
            {/* Creater New popup start here */}
            <div
                className="modal fade creator-form-wrap"
                id="creator-pop-new"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                data-backdrop="static"
                // data-keyboard= "false"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Personal Details
                            </h5>
                            <button
                                type="button"
                                className="close"
                                form="formOne"
                                // data-dismiss="modal"
                                onClick={() => resetForm()}
                            >
                                <span aria-hidden="true">
                                    <img className="closeModal" src={Close_black} alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body common-scroll">
                            <div className="react-tab-wrap creator-tabs">
                                <Tabs
                                    onSelect={(tabIndex) => setSelectedTabs(tabIndex)}
                                    selectedIndex={
                                        selectedTabs === 0 ? 0 : selectedTabs === 1 ? 1 : 2
                                    }
                                >
                                    <TabList>
                                        <Tab>Basic Details</Tab>
                                        <Tab> Physical Attributes</Tab>
                                        <Tab> Personality Traits</Tab>
                                    </TabList>
                                    <>
                                        <form
                                            id="formOne"
                                            key={1}
                                            onSubmit={handleSubmit((data) => setBasicSubmit(data))}
                                        >
                                            <TabPanel>
                                                <div className="react-tab-content-wrap common-scroll">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap custom-select-mui">
                                                                {/* <img
                                                                    className="select-type"
                                                                    src={scaleMark}
                                                                    alt=""
                                                                /> */}
                                                                <label htmlFor="">

                                                                    <img src={formIcon1} alt="" />Height
                                                                </label>
                                                                <Controller
                                                                    name="height_feet"
                                                                    refs={register("height_feet")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            menuPosition="fixed"
                                                                            placeholder={"Height feet"}
                                                                            {...field}
                                                                            options={feetJSON}
                                                                            styles={customStyles}
                                                                            defaultValue={"'5"}
                                                                        />
                                                                    )}
                                                                    control={control}
                                                                    defaultValue=""
                                                                />
                                                                {errors.height_feet && (
                                                                    <p className="required">
                                                                        {errors.height_feet.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap custom-select-mui scale-mark-mob">
                                                                {/* <img
                                                                    className="select-type"
                                                                    src={scaleMark}
                                                                    alt=""
                                                                /> */}
                                                                <label className="lable-blank" htmlFor="">&nbsp;</label>
                                                                <Controller
                                                                    name="height_inch"
                                                                    refs={register("height_inch")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            menuPosition="fixed"
                                                                            placeholder={"Height inch"}
                                                                            {...field}
                                                                            options={inchesJSON}
                                                                        />
                                                                    )}
                                                                    control={control}
                                                                    defaultValue=""
                                                                />
                                                                {errors.height_inch && (
                                                                    <p className="required">
                                                                        {errors.height_inch.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="input-label-wrap">
                                                                <label htmlFor="">
                                                                    {" "}
                                                                    <img src={formIcon2} alt="" />Weight
                                                                </label>
                                                                <input
                                                                    {...register("weight")}
                                                                    className="form-control"
                                                                    type="number"
                                                                    onKeyDown={(evt) => ["e", "E"].includes(evt.key) && evt.preventDefault()}
                                                                    name="weight"
                                                                    placeholder="Enter your weight (in kg)"
                                                                />
                                                                {errors.weight && (
                                                                    <p className="required">
                                                                        {errors.weight.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div data-toggle="modal"
                                                                data-target="#open-date-picker"
                                                                className="input-label-wrap"
                                                            >
                                                                <label htmlFor="">
                                                                    <img src={formIcon3} alt="" />How old are you?
                                                                </label>
                                                                <input
                                                                    {...register("dob")}
                                                                    value={
                                                                        agePicker
                                                                            ? moment(agePicker).format("DD-MM-YYYY")
                                                                            : ""
                                                                    }
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="dob"
                                                                    autoComplete="off"
                                                                    placeholder="Enter your date of birth"
                                                                />
                                                                <img
                                                                    className="calender-mark"
                                                                    src={CalenderMark}
                                                                    alt=""
                                                                />
                                                                {errors.dob && (
                                                                    <p className="required">
                                                                        {errors.dob.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="input-label-wrap">
                                                                <label htmlFor="">
                                                                    ️<img src={formIcon4} alt="" />Which languages do
                                                                    you prefer to speak in?
                                                                </label>
                                                                <Controller
                                                                    refs={register("languages")}
                                                                    name="languages"
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            menuPosition="fixed"
                                                                            placeholder={
                                                                                "Enter your preferred language"
                                                                            }
                                                                            {...field}
                                                                            isMulti
                                                                            classNamePrefix="react-select"
                                                                            isClearable={false}
                                                                            options={dropDownValues?.language}
                                                                            getOptionLabel={(option) => option.text}
                                                                            styles={customStyles}
                                                                        />
                                                                    )}
                                                                    control={control}
                                                                    defaultValue=""
                                                                />
                                                                {errors.languages && (
                                                                    <p className="required">
                                                                        {errors.languages.message}
                                                                    </p>
                                                                )}

                                                            </div>
                                                            {basicDataFormData?.languages?.some(a => a.value === "other") &&
                                                                <div className="input-label-wrap others-label">
                                                                    <Controller
                                                                        refs={register("other_languages")}
                                                                        name="other_languages"
                                                                        control={control}
                                                                        render={({ field }) => (
                                                                            <MuiChipsInput
                                                                                autoComplete="off"
                                                                                renderChip={(Component, key, props) => {
                                                                                    return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                                }}
                                                                                className="form-control"
                                                                                hideClearAll
                                                                                type="text"
                                                                                placeholder={getValues("other_languages")?.length === 0 || getValues("other_languages") === undefined ? "Other (Please Specify)" : false}
                                                                                addOnWhichKey={[",", "Enter"]}
                                                                                {...field}
                                                                            />
                                                                        )}
                                                                    />
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                        </form>
                                        <form
                                            id="formTwo"
                                            key={2}
                                            onSubmit={handleSubmit2((data) =>
                                                setPhysicalSubmit(data)
                                            )}
                                        >
                                            <TabPanel>
                                                <div className="react-tab-content-wrap common-scroll">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="input-label-wrap first-heading">
                                                                <label htmlFor="">
                                                                    {" "}
                                                                    <img src={formIcon5} alt="" />Hair Type
                                                                    {/* Hover Tooltip UI for Labels */}
                                                                    <div className="custom-tool-tip">
                                                                        <div className="tooltip-overlay"></div>
                                                                        <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                                            className="more-btn-brand"
                                                                            href="javascript:void(0)"
                                                                        >
                                                                            <img src={TooltipIcon} alt="tool" />
                                                                            <div className="right_tooltip">
                                                                                <div
                                                                                    className="dropdown-menu dropdown-toggle more-dropdown-brand"
                                                                                    aria-labelledby="dropdownMenuButton "
                                                                                >
                                                                                    <div className="tooltip-heading">
                                                                                        <span>Hair type</span>
                                                                                    </div>
                                                                                    <div className="dropdown-wrap-area common-scroll">
                                                                                        <a href="javascript:void(0);">
                                                                                            <span>Curly<b>-</b> </span>
                                                                                            Curved or spiral in shape
                                                                                        </a>
                                                                                        <a href="javascript:void(0);" >
                                                                                            <span>Coily<b>-</b> </span>
                                                                                            small, tight curls, or zigzag-shaped hairs with more defined ringlets
                                                                                        </a>
                                                                                        <a href="javascript:void(0);" >
                                                                                            <span>Straight<b>-</b> </span>
                                                                                            Fine threads, does not curl easily with no bend or curve
                                                                                        </a>
                                                                                        <a href="javascript:void(0);" >
                                                                                            <span> Waivy<b>-</b> </span>
                                                                                            generally straight-looking at the top, then falling down in a tousled look (s-shaped)
                                                                                        </a>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                    {/* Hover Tooltip UI for Labels */}
                                                                </label>
                                                                <div className="radio-button-wrap">
                                                                    <div className="custom-radio-btn">
                                                                        {dropDownValues?.hairType?.map(
                                                                            (obj, key) => {
                                                                                return (
                                                                                    <div className="radio-buttons" key={key}>
                                                                                        <input
                                                                                            {...register2("hair_type")}
                                                                                            type="radio"
                                                                                            id={obj.text}
                                                                                            value={obj.text}
                                                                                        />
                                                                                        <label for={obj.text}>
                                                                                            {obj.text}
                                                                                        </label>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        )}
                                                                    </div>
                                                                    {errors2.hair_type && (
                                                                        <p className="required">
                                                                            {errors2.hair_type.message}
                                                                        </p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap">
                                                                <label htmlFor="">
                                                                    <img src={formIcon6} alt="" />Hair Color
                                                                </label>
                                                                <Controller
                                                                    name="hair_color"
                                                                    refs={register2("hair_color")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            placeholder={"Enter your hair color"}
                                                                            menuPosition="fixed"
                                                                            {...field}
                                                                            options={dropDownValues?.hairColors}
                                                                            getOptionLabel={(option) => option.text}
                                                                        />
                                                                    )}
                                                                    control={control2}
                                                                    defaultValue=""
                                                                />
                                                                {errors2.hair_color && (
                                                                    <p className="required">
                                                                        {errors2.hair_color.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                            {physicalFormData?.hair_color?.value === "other" &&
                                                                <div class="input-label-wrap others-label">
                                                                    <Controller
                                                                        refs={register2("other_hair_color")}
                                                                        name="other_hair_color"
                                                                        control={control2}
                                                                        render={({ field }) => (
                                                                            <MuiChipsInput
                                                                                autoComplete="off"
                                                                                renderChip={(Component, key, props) => {
                                                                                    return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                                }}
                                                                                hideClearAll
                                                                                className="form-control"
                                                                                type="text"
                                                                                placeholder={getValuesTwo("other_hair_color")?.length === 0 || getValuesTwo("other_hair_color") === undefined ? "Other (Please Specify)" : false}
                                                                                addOnWhichKey={[",", "Enter"]}
                                                                                {...field}
                                                                            />
                                                                        )}
                                                                    />
                                                                    {/* <input  {...register2("other_hair_color")} onKeyPress={(e) => {
                                                                        if (e.key === ",") {
                                                                            e.preventDefault();
                                                                        }
                                                                    }} class="form-control" type="text" name="other_hair_color" placeholder="Other (Please Specify)" /> */}
                                                                </div>}
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap">
                                                                <label htmlFor="">
                                                                    <img src={formIcon7} alt="" />Hair Length
                                                                </label>
                                                                <Controller
                                                                    name="hair_length"
                                                                    refs={register2("hair_length")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            placeholder={"Enter your hair length"}
                                                                            menuPosition="fixed"
                                                                            {...field}
                                                                            options={dropDownValues?.hair_length}
                                                                            getOptionLabel={(option) => option.text}
                                                                        />
                                                                    )}
                                                                    control={control2}
                                                                    defaultValue=""
                                                                />
                                                                {errors2.hair_length && (
                                                                    <p className="required">
                                                                        {errors2.hair_length.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                            {physicalFormData?.hair_length?.value === "other" &&
                                                                <div class="input-label-wrap others-label">
                                                                    <Controller
                                                                        refs={register2("other_hair_length")}
                                                                        name="other_hair_length"
                                                                        control={control2}
                                                                        render={({ field }) => (
                                                                            <MuiChipsInput
                                                                                autoComplete="off"
                                                                                renderChip={(Component, key, props) => {
                                                                                    return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                                }}
                                                                                hideClearAll
                                                                                className="form-control"
                                                                                type="text"
                                                                                placeholder={getValuesTwo("other_hair_length")?.length === 0 || getValuesTwo("other_hair_length") === undefined ? "Other (Please Specify)" : false}
                                                                                addOnWhichKey={[",", "Enter"]}
                                                                                {...field}
                                                                            />
                                                                        )}
                                                                    />
                                                                </div>}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap custom-select-mui scale-mark-mob">
                                                                <label htmlFor="">
                                                                    <img src={formIcon8} alt="" />How many tattoos do you have?
                                                                </label>
                                                                <Controller
                                                                    name="count_tattoo"
                                                                    refs={register2("count_tattoo")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            placeholder={"Select quantity"}
                                                                            menuPosition="fixed"
                                                                            {...field}
                                                                            options={countJSON}
                                                                        />
                                                                    )}
                                                                    control={control2}
                                                                    defaultValue=""
                                                                />
                                                                {errors2.count_tattoo && (
                                                                    <p className="required">
                                                                        {errors2.count_tattoo.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap">
                                                                <label className="lable-blank" htmlFor="">&nbsp;</label>
                                                                <Controller

                                                                    name="tattoos"
                                                                    refs={register2("tattoos")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            menuPosition="fixed"
                                                                            placeholder={"Select places you have tattoos"}
                                                                            {...field}
                                                                            isMulti
                                                                            onKeyDown={(e) => {
                                                                                if ((parseInt(getValuesTwo("count_tattoo")?.value) === 0)) {
                                                                                    e.preventDefault()
                                                                                    return
                                                                                }
                                                                            }
                                                                            }
                                                                            classNamePrefix="react-select"
                                                                            isClearable={false}
                                                                            isDisabled={parseInt(physicalFormData?.count_tattoo?.value) === 0 || physicalFormData?.count_tattoo?.value === undefined}
                                                                            isOptionDisabled={() => physicalFormData?.count_tattoo?.value <= physicalFormData?.tattoos?.length || (physicalFormData?.tattoos?.some(a => a.value === "other") ? physicalFormData?.tattoos?.length - 1 + physicalFormData?.other_tattoos?.length === parseInt(physicalFormData?.count_tattoo?.value) : false)}
                                                                            options={dropDownValues?.tattoosBodyParts}
                                                                            getOptionLabel={(option) => option.text}
                                                                        />
                                                                    )}
                                                                    control={control2}
                                                                    defaultValue=""
                                                                />
                                                                {errors2.tattoos && (
                                                                    <p className="required">
                                                                        {errors2.tattoos.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {physicalFormData?.tattoos?.some(a => a.value === "other") && <div className="col-md-12">
                                                            <div class="input-label-wrap others-label">
                                                                <Controller
                                                                    refs={register2("other_tattoos")}
                                                                    name="other_tattoos"
                                                                    control={control2}
                                                                    render={({ field }) => (
                                                                        <MuiChipsInput
                                                                            autoComplete="off"
                                                                            renderChip={(Component, key, props) => {
                                                                                return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                            }}
                                                                            hideClearAll
                                                                            className={parseInt(getValuesTwo("count_tattoo")?.value) <= getValuesTwo("other_tattoos")?.length + (getValuesTwo("tattoos")?.length - 1) ? 'blinking-cursor form-control' : 'form-control'}
                                                                            onKeyDown={(e) => {
                                                                                if ((parseInt(getValuesTwo("count_tattoo")?.value) <= getValuesTwo("other_tattoos")?.length + (getValuesTwo("tattoos")?.length - 1))) {
                                                                                    e.preventDefault()
                                                                                    return
                                                                                }
                                                                            }
                                                                            }
                                                                            type="text"
                                                                            placeholder={getValuesTwo("other_tattoos")?.length === 0 || getValuesTwo("other_tattoos") === undefined ? "Others (please specify)" : false}
                                                                            addOnWhichKey={[",", "Enter"]}
                                                                            {...field}
                                                                        />
                                                                    )}
                                                                />
                                                            </div>
                                                        </div>}
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap custom-select-mui scale-mark-mob">
                                                                <label htmlFor="">
                                                                    <img src={formIcon9} alt="" />How many piercings do you have?
                                                                    {/* Hover Tooltip UI for Labels */}
                                                                    <div className="custom-tool-tip">
                                                                        <div className="tooltip-overlay"></div>
                                                                        <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                                            className="more-btn-brand"
                                                                            href="javascript:void(0)"
                                                                        >
                                                                            <img src={TooltipIcon} alt="tool" />
                                                                            <div className="right_tooltip">
                                                                                <div
                                                                                    className="dropdown-menu dropdown-toggle more-dropdown-brand"
                                                                                    aria-labelledby="dropdownMenuButton "
                                                                                >
                                                                                    <div className="tooltip-heading">
                                                                                        <span>Piercing</span>
                                                                                    </div>
                                                                                    <div className="dropdown-wrap-area common-scroll">
                                                                                        <a href="javascript:void(0);">
                                                                                            <span>Piercing<b>-</b> </span>
                                                                                            Any holes, slots and notches in your body with a ring or stud, that is attached to pierced flesh
                                                                                        </a>

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                    {/* Hover Tooltip UI for Labels */}
                                                                </label>
                                                                <Controller
                                                                    name="count_piercing"
                                                                    refs={register2("count_piercing")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            menuPosition="fixed"
                                                                            placeholder={"Select quantity"}
                                                                            {...field}
                                                                            options={countJSON}
                                                                        />
                                                                    )}
                                                                    control={control2}
                                                                    defaultValue=""
                                                                />
                                                                {errors.count_piercing && (
                                                                    <p className="required">
                                                                        {errors.count_piercing.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap">
                                                                <label className="lable-blank" htmlFor="">&nbsp;</label>
                                                                <Controller
                                                                    name="piercing"
                                                                    refs={register2("piercing")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            menuPosition="fixed"
                                                                            placeholder={"Select places you have piercing"}
                                                                            {...field}
                                                                            isMulti
                                                                            onKeyDown={(e) => {
                                                                                if ((parseInt(getValuesTwo("count_piercing")?.value) === 0)) {
                                                                                    e.preventDefault()
                                                                                    return
                                                                                }
                                                                            }
                                                                            }
                                                                            classNamePrefix="react-select"
                                                                            isClearable={false}
                                                                            isDisabled={parseInt(physicalFormData?.count_piercing?.value) === 0 || physicalFormData?.count_piercing?.value === undefined}
                                                                            isOptionDisabled={() => physicalFormData?.count_piercing?.value <= physicalFormData?.piercing?.length || (physicalFormData?.piercing?.some(a => a.value === "other") ? physicalFormData?.piercing?.length - 1 + physicalFormData?.other_piercing?.length === parseInt(physicalFormData?.count_piercing?.value) : false)}
                                                                            options={dropDownValues?.piercingBodyParts}
                                                                            getOptionLabel={(option) => option.text}
                                                                        />
                                                                    )}
                                                                    control={control2}
                                                                    defaultValue=""
                                                                />
                                                                {errors2.piercing && (
                                                                    <p className="required">
                                                                        {errors2.piercing.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {physicalFormData?.piercing?.some(a => a.value === "other") && <div className="col-md-12">
                                                            <div class="input-label-wrap others-label">
                                                                <Controller
                                                                    refs={register2("other_piercing")}
                                                                    name="other_piercing"
                                                                    control={control2}
                                                                    render={({ field }) => (
                                                                        <MuiChipsInput
                                                                            autoComplete="off"
                                                                            renderChip={(Component, key, props) => {
                                                                                return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                            }}
                                                                            hideClearAll
                                                                            onKeyDown={(e) => {
                                                                                if ((parseInt(getValuesTwo("count_piercing")?.value) <= getValuesTwo("other_piercing")?.length + (getValuesTwo("piercing")?.length - 1))) {
                                                                                    e.preventDefault()
                                                                                    return
                                                                                }
                                                                            }
                                                                            }
                                                                            className={parseInt(getValuesTwo("count_piercing")?.value) <= getValuesTwo("other_piercing")?.length + (getValuesTwo("piercing")?.length - 1) ? 'blinking-cursor form-control' : 'form-control'}
                                                                            type="text"
                                                                            placeholder={getValuesTwo("other_piercing")?.length === 0 || getValuesTwo("other_piercing") === undefined ? "Others (please specify)" : false}
                                                                            addOnWhichKey={[",", "Enter"]}
                                                                            {...field}
                                                                        />
                                                                    )}
                                                                />
                                                            </div>
                                                        </div>}
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap custom-select-mui scale-mark-mob">
                                                                <label htmlFor="">
                                                                    <img src={formIcon10} alt="" />How many moles do you have?
                                                                    {/* Hover Tooltip UI for Labels */}
                                                                    <div className="custom-tool-tip">
                                                                        <div className="tooltip-overlay"></div>
                                                                        <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                                            className="more-btn-brand"
                                                                            href="javascript:void(0)"
                                                                        >
                                                                            <img src={TooltipIcon} alt="tool" />
                                                                            <div className="right_tooltip">
                                                                                <div
                                                                                    className="dropdown-menu dropdown-toggle more-dropdown-brand"
                                                                                    aria-labelledby="dropdownMenuButton "
                                                                                >
                                                                                    <div className="tooltip-heading">
                                                                                        <span>Moles</span>
                                                                                    </div>
                                                                                    <div className="dropdown-wrap-area common-scroll">
                                                                                        <a href="javascript:void(0);">
                                                                                            <span>Mole<b>-</b> </span>
                                                                                            Moles are growth on the skin that are usually brown or black, it can be multiple in no.
                                                                                        </a>

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                    {/* Hover Tooltip UI for Labels */}
                                                                </label>
                                                                <Controller
                                                                    name="count_mole"
                                                                    refs={register2("count_mole")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            menuPosition="fixed"
                                                                            placeholder={"select quantity"}
                                                                            {...field}
                                                                            options={countJSON}
                                                                        />
                                                                    )}
                                                                    control={control2}
                                                                    defaultValue=""
                                                                />
                                                                {errors.count_mole && (
                                                                    <p className="required">
                                                                        {errors.count_mole.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap">
                                                                <label className="lable-blank" htmlFor="">&nbsp;</label>
                                                                <Controller
                                                                    name="birthmark_moles"
                                                                    refs={register2("birthmark_moles")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            placeholder={"Select places you have moles"}
                                                                            menuPosition="fixed"
                                                                            {...field}
                                                                            onKeyDown={(e) => {
                                                                                if ((parseInt(getValuesTwo("count_mole")?.value) === 0)) {
                                                                                    e.preventDefault()
                                                                                    return
                                                                                }
                                                                            }
                                                                            }
                                                                            options={dropDownValues?.birthmarkBodyParts}
                                                                            getOptionLabel={(option) => option.text}
                                                                            isMulti
                                                                            isDisabled={parseInt(physicalFormData?.count_mole?.value) === 0 || physicalFormData?.count_mole?.value === undefined}
                                                                            isOptionDisabled={() => physicalFormData?.count_mole?.value <= physicalFormData?.birthmark_moles?.length || (physicalFormData?.birthmark_moles?.some(a => a.value === "other") ? physicalFormData?.birthmark_moles?.length - 1 + physicalFormData?.other_birthmark_moles?.length === parseInt(physicalFormData?.count_mole?.value) : false)}
                                                                            classNamePrefix="react-select"
                                                                            isClearable={false}
                                                                        />
                                                                    )}
                                                                    control={control2}
                                                                    defaultValue=""
                                                                />
                                                                {errors2.birthmark_moles && (
                                                                    <p className="required">
                                                                        {errors2.birthmark_moles.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {physicalFormData?.birthmark_moles?.some(a => a.value === "other") && <div className="col-md-12">
                                                            <div class="input-label-wrap others-label">
                                                                <Controller
                                                                    refs={register2("other_birthmark_moles")}
                                                                    name="other_birthmark_moles"
                                                                    control={control2}
                                                                    render={({ field }) => (
                                                                        <MuiChipsInput
                                                                            autoComplete="off"
                                                                            renderChip={(Component, key, props) => {
                                                                                return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                            }}
                                                                            hideClearAll
                                                                            className={parseInt(getValuesTwo("count_mole")?.value) <= getValuesTwo("other_birthmark_moles")?.length + (getValuesTwo("birthmark_moles")?.length - 1) ? 'blinking-cursor form-control' : 'form-control'}
                                                                            type="text"
                                                                            onKeyDown={(e) => {
                                                                                if ((parseInt(getValuesTwo("count_mole")?.value) <= getValuesTwo("other_birthmark_moles")?.length + (getValuesTwo("birthmark_moles")?.length - 1))) {
                                                                                    e.preventDefault()
                                                                                    return
                                                                                }
                                                                            }
                                                                            }
                                                                            placeholder={getValuesTwo("other_birthmark_moles")?.length === 0 || getValuesTwo("other_birthmark_moles") === undefined ? "Others (please specify)" : false}
                                                                            addOnWhichKey={[",", "Enter"]}
                                                                            {...field}
                                                                        />
                                                                    )}
                                                                />
                                                            </div>
                                                        </div>}
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap">
                                                                <label htmlFor="">
                                                                    <img src={formIcon11} alt="" />Skin Color
                                                                </label>
                                                                <Controller
                                                                    name="skin_color"
                                                                    refs={register2("skin_color")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            placeholder={"Enter your skin color"}
                                                                            menuPosition="fixed"
                                                                            {...field}
                                                                            options={dropDownValues?.skinColors}
                                                                            getOptionLabel={(option) => option.text}
                                                                        />
                                                                    )}
                                                                    control={control2}
                                                                    defaultValue=""
                                                                />
                                                                {errors2.skin_color && (
                                                                    <p className="required">
                                                                        {errors2.skin_color.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap">
                                                                <label htmlFor="">
                                                                    <img src={formIcon12} alt="" />Eye Color
                                                                </label>
                                                                <Controller
                                                                    name="eye_color"
                                                                    refs={register2("eye_color")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            placeholder={"Enter your eye color"}
                                                                            menuPosition="fixed"
                                                                            {...field}
                                                                            options={dropDownValues?.eyeColors}
                                                                            getOptionLabel={(option) => option.text}
                                                                        />
                                                                    )}
                                                                    control={control2}
                                                                    defaultValue=""
                                                                />
                                                                {errors2.eye_color && (
                                                                    <p className="required">
                                                                        {errors2.eye_color.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap">
                                                                <label htmlFor="">
                                                                    <img src={formIcon13} alt="" />Body Type
                                                                    {/* Hover Tooltip UI for Labels */}
                                                                    <div className="custom-tool-tip tooltip-bottom-side">
                                                                        <div className="tooltip-overlay"></div>
                                                                        <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                                            className="more-btn-brand"
                                                                            href="javascript:void(0)"
                                                                        >
                                                                            <img src={TooltipIcon} alt="tool" />
                                                                            <div className="right_tooltip">
                                                                                <div
                                                                                    className="dropdown-menu dropdown-toggle more-dropdown-brand"
                                                                                    aria-labelledby="dropdownMenuButton "
                                                                                >
                                                                                    <div className="tooltip-heading">
                                                                                        <span>Body Type</span>
                                                                                    </div>
                                                                                    <div className="dropdown-wrap-area common-scroll">
                                                                                        <a href="javascript:void(0);">
                                                                                            <span>Curvy<b>-</b> </span>
                                                                                            fuller, rounder figures of all proportions
                                                                                        </a>
                                                                                        <a href="javascript:void(0);">
                                                                                            <span>Athletic<b>-</b> </span>

                                                                                            muscular body and well-built shoulders
                                                                                        </a>
                                                                                        <a href="javascript:void(0);">
                                                                                            <span>Hourglass<b>-</b> </span>
                                                                                            top and bottom halves of the body are equally broad
                                                                                        </a>
                                                                                        <a href="javascript:void(0);">
                                                                                            <span>Oval<b>-</b> </span>
                                                                                            top and bottom halves of the body are narrow.
                                                                                        </a>
                                                                                        <a href="javascript:void(0);">
                                                                                            <span>Pear<b>-</b> </span>
                                                                                            narrower shoulders than hips
                                                                                        </a>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                    {/* Hover Tooltip UI for Labels */}
                                                                </label>
                                                                <Controller
                                                                    name="body_type"
                                                                    refs={register2("body_type")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            placeholder={"Enter your body type"}
                                                                            menuPosition="fixed"
                                                                            {...field}
                                                                            options={dropDownValues?.bodyTypes}
                                                                            getOptionLabel={(option) => option.text}
                                                                        />
                                                                    )}
                                                                    control={control2}
                                                                    defaultValue=""
                                                                />
                                                                {errors2.body_type && (
                                                                    <p className="required">
                                                                        {errors2.body_type.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap">
                                                                <label htmlFor="">
                                                                    <img src={formIcon14} alt="" />Strength
                                                                </label>
                                                                <Controller
                                                                    name="strength"
                                                                    refs={register2("strength")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            placeholder={"Enter your Body Physique"}
                                                                            menuPosition="fixed"
                                                                            {...field}
                                                                            options={dropDownValues?.strengths}
                                                                            getOptionLabel={(option) => option.text}
                                                                        />
                                                                    )}
                                                                    control={control2}
                                                                    defaultValue=""
                                                                />
                                                                {errors2.strength && (
                                                                    <p className="required">
                                                                        {errors2.strength.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap">
                                                                <label htmlFor="">
                                                                    <img src={formIcon15} alt="" />Voice type
                                                                    {/* Hover Tooltip UI for Labels */}
                                                                    <div className="custom-tool-tip tooltip-bottom-side">
                                                                        <div className="tooltip-overlay"></div>
                                                                        <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                                            className="more-btn-brand"
                                                                            href="javascript:void(0)"
                                                                        >
                                                                            <img src={TooltipIcon} alt="tool" />
                                                                            <div className="right_tooltip">
                                                                                <div
                                                                                    className="dropdown-menu dropdown-toggle more-dropdown-brand"
                                                                                    aria-labelledby="dropdownMenuButton "
                                                                                >
                                                                                    <div className="tooltip-heading">
                                                                                        <span>Voice Type</span>
                                                                                    </div>
                                                                                    <div className="dropdown-wrap-area common-scroll">
                                                                                        <a href="javascript:void(0);">
                                                                                            <span>Shrill<b>-</b> </span>
                                                                                            very loud and high
                                                                                        </a>
                                                                                        <a href="javascript:void(0);">
                                                                                            <span>High pitch<b>-</b> </span>

                                                                                            higher in volume or tone than usual
                                                                                        </a>
                                                                                        <a href="javascript:void(0);">
                                                                                            <span>Low pitch<b>-</b> </span>
                                                                                            very soft and quiet
                                                                                        </a>
                                                                                        <a href="javascript:void(0);">
                                                                                            <span>Husky<b>-</b> </span>
                                                                                            having a semi-whispered vocal tone; sound breathy, raspy, or strained, somewhat hoarse
                                                                                        </a>

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                    {/* Hover Tooltip UI for Labels */}
                                                                </label>
                                                                <Controller
                                                                    refs={register2("voice_type")}
                                                                    name="voice_type"
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            placeholder={"Enter your voice Type"}
                                                                            menuPosition="fixed"
                                                                            {...field}
                                                                            options={dropDownValues?.voiceTypes}
                                                                            getOptionLabel={(option) => option.text}
                                                                        />
                                                                    )}
                                                                    control={control2}
                                                                    defaultValue=""
                                                                />
                                                                {errors2.voice_type && (
                                                                    <p className="required">
                                                                        {errors2.voice_type.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                        </form>
                                        <form
                                            id="formThree"
                                            onSubmit={handleSubmit3((data) =>
                                                setPersonalitySubmit(data)
                                            )}
                                        >
                                            <TabPanel>
                                                <div className="react-tab-content-wrap common-scroll">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap">
                                                                <label htmlFor="">
                                                                    <img src={formIcon18} alt="" />Adjectives that best describe you
                                                                    {/* Hover Tooltip UI for Labels */}
                                                                    <div className="custom-tool-tip">
                                                                        <div className="tooltip-overlay"></div>
                                                                        <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                                            className="more-btn-brand"
                                                                            href="javascript:void(0)"
                                                                        >
                                                                            <img src={TooltipIcon} alt="tool" />
                                                                            <div className="right_tooltip">
                                                                                <div
                                                                                    className="dropdown-menu dropdown-toggle more-dropdown-brand"
                                                                                    aria-labelledby="dropdownMenuButton "
                                                                                >
                                                                                    <div className="tooltip-heading">
                                                                                        <span>Adjectives that best describe you</span>
                                                                                    </div>
                                                                                    <div className="dropdown-wrap-area common-scroll">
                                                                                        <a href="javascript:void(0);">
                                                                                            {/* <span> <b>-</b> </span> */}
                                                                                            Intangible words/phrases that help describe your personality
                                                                                        </a>


                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                    {/* Hover Tooltip UI for Labels */}
                                                                </label>
                                                                <Controller
                                                                    name="adjectives"
                                                                    refs={register3("adjectives")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            placeholder={
                                                                                "Select your prefered adjectives"
                                                                            }
                                                                            menuPosition="fixed"
                                                                            {...field}
                                                                            options={dropDownValues?.adjectives}
                                                                            getOptionLabel={(option) => option.text}
                                                                            isMulti
                                                                            classNamePrefix="react-select"
                                                                            isClearable={false}
                                                                        />
                                                                    )}
                                                                    control={control3}
                                                                    defaultValue=""
                                                                />
                                                                {errors3.adjectives && (
                                                                    <p className="required">
                                                                        {errors3.adjectives.message}
                                                                    </p>
                                                                )}
                                                            </div>

                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap">
                                                                <label htmlFor="">
                                                                    <img src={formIcon19} alt="" />Brands you've worked with
                                                                    {/* Hover Tooltip UI for Labels */}
                                                                    <div className="custom-tool-tip tooltip-right-side">
                                                                        <div className="tooltip-overlay"></div>
                                                                        <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                                            className="more-btn-brand"
                                                                            href="javascript:void(0)"
                                                                        >
                                                                            <img src={TooltipIcon} alt="tool" />
                                                                            <div className="right_tooltip">
                                                                                <div
                                                                                    className="dropdown-menu dropdown-toggle more-dropdown-brand"
                                                                                    aria-labelledby="dropdownMenuButton "
                                                                                >
                                                                                    <div className="tooltip-heading">
                                                                                        <span>Brands you've worked with</span>
                                                                                    </div>
                                                                                    <div className="dropdown-wrap-area common-scroll">
                                                                                        <a href="javascript:void(0);">
                                                                                            {/* <span> <b>-</b> </span> */}
                                                                                            Official paid brand collaborations. Eg. Fashion brand collabs
                                                                                        </a>


                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                    {/* Hover Tooltip UI for Labels */}
                                                                </label>
                                                                <Controller
                                                                    refs={register3("associated_brands")}
                                                                    name="associated_brands"
                                                                    control={control3}
                                                                    render={({ field }) => (
                                                                        <MuiChipsInput
                                                                            autoComplete="off"
                                                                            hideClearAll
                                                                            renderChip={(Component, key, props) => {
                                                                                return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                            }}
                                                                            addOnWhichKey={[",", "Enter"]}
                                                                            type="text"
                                                                            name="associated_brands"
                                                                            placeholder={getValuesThree("associated_brands")?.length === 0 || getValuesThree("associated_brands") === undefined ? "Enter the name of the brands" : false}
                                                                            {...field}
                                                                        />
                                                                    )}
                                                                />
                                                                {errors3.associated_brands && (
                                                                    <p className="required">
                                                                        {errors3.associated_brands.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">

                                                            {personalFormData?.adjectives?.some(a => a.value === "other") && <div class="input-label-wrap others-label">
                                                                <Controller
                                                                    refs={register2("other_adjectives")}
                                                                    name="other_adjectives"
                                                                    control={control3}
                                                                    render={({ field }) => (
                                                                        <MuiChipsInput
                                                                            autoComplete="off"
                                                                            renderChip={(Component, key, props) => {
                                                                                return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                            }}
                                                                            hideClearAll
                                                                            className="form-control"
                                                                            type="text"
                                                                            placeholder={getValuesThree("other_adjectives")?.length === 0 || getValuesThree("other_adjectives") === undefined ? "Other (Please Specify)" : false}
                                                                            addOnWhichKey={[",", "Enter"]}
                                                                            {...field}
                                                                        />
                                                                    )}
                                                                />
                                                            </div>}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap">
                                                                <label htmlFor="">
                                                                    <img src={formIcon20} alt="" />Other Skills
                                                                    {/* Hover Tooltip UI for Labels */}
                                                                    <div className="custom-tool-tip">
                                                                        <div className="tooltip-overlay"></div>
                                                                        <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                                            className="more-btn-brand"
                                                                            href="javascript:void(0)"
                                                                        >
                                                                            <img src={TooltipIcon} alt="tool" />
                                                                            <div className="right_tooltip">
                                                                                <div
                                                                                    className="dropdown-menu dropdown-toggle more-dropdown-brand"
                                                                                    aria-labelledby="dropdownMenuButton "
                                                                                >
                                                                                    <div className="tooltip-heading">
                                                                                        <span>Other Skills</span>
                                                                                    </div>
                                                                                    <div className="dropdown-wrap-area common-scroll">
                                                                                        <a href="javascript:void(0);">
                                                                                            {/* <span> <b>-</b> </span> */}
                                                                                            A learned power developed via aptitude or ability. Eg. time management, teamwork and leadership etc
                                                                                        </a>


                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                    {/* Hover Tooltip UI for Labels */}
                                                                </label>
                                                                <Controller
                                                                    refs={register3("other_skills")}
                                                                    name="other_skills"
                                                                    control={control3}
                                                                    render={({ field }) => (
                                                                        <MuiChipsInput
                                                                            autoComplete="off"
                                                                            hideClearAll
                                                                            renderChip={(Component, key, props) => {
                                                                                return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                            }}
                                                                            addOnWhichKey={[",", "Enter"]}
                                                                            type="text"
                                                                            name="other_skills"
                                                                            placeholder={getValuesThree("other_skills")?.length === 0 || getValuesThree("other_skills") === undefined ? "Enter your skills here" : false}
                                                                            {...field}
                                                                        />
                                                                    )}
                                                                />
                                                                {errors3.other_skills && (
                                                                    <p className="required">
                                                                        {errors3.other_skills.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap">
                                                                <label htmlFor="">
                                                                    ‍<img src={formIcon21} alt="" />Awards / Recognition received
                                                                    {/* Hover Tooltip UI for Labels */}
                                                                    <div className="custom-tool-tip tooltip-right-side">
                                                                        <div className="tooltip-overlay"></div>
                                                                        <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                                            className="more-btn-brand"
                                                                            href="javascript:void(0)"
                                                                        >
                                                                            <img src={TooltipIcon} alt="tool" />
                                                                            <div className="right_tooltip">
                                                                                <div
                                                                                    className="dropdown-menu dropdown-toggle more-dropdown-brand"
                                                                                    aria-labelledby="dropdownMenuButton "
                                                                                >
                                                                                    <div className="tooltip-heading">
                                                                                        <span>Awards / Recognition received</span>
                                                                                    </div>
                                                                                    <div className="dropdown-wrap-area common-scroll">
                                                                                        <a href="javascript:void(0);">
                                                                                            {/* <span> <b>-</b> </span> */}
                                                                                            A tangible form of appreciation given for your contribution or  accomplishment. Eg. Best Influencer award by xyz brand, dada saheb phalke award etc
                                                                                        </a>


                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                    {/* Hover Tooltip UI for Labels */}
                                                                </label>
                                                                <Controller
                                                                    refs={register3("awards")}
                                                                    name="awards"
                                                                    control={control3}
                                                                    render={({ field }) => (
                                                                        <MuiChipsInput
                                                                            autoComplete="off"
                                                                            hideClearAll
                                                                            renderChip={(Component, key, props) => {
                                                                                return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                            }}
                                                                            addOnWhichKey={[",", "Enter"]}
                                                                            type="text"
                                                                            name="awards"
                                                                            placeholder={getValuesThree("awards")?.length === 0 || getValuesThree("awards") === undefined ? "Enter your awards name" : false}
                                                                            {...field}
                                                                        />
                                                                    )}
                                                                />
                                                                {errors3.awards && (
                                                                    <p className="required">
                                                                        {errors3.awards.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap">
                                                                <label htmlFor="">
                                                                    <img src={formIcon22} alt="" />Phone Brand
                                                                </label>
                                                                <Controller
                                                                    name="phone_brand"
                                                                    refs={register3("phone_brand")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            isMulti
                                                                            isClearable={false}
                                                                            placeholder={"Enter Your Phone Brand"}
                                                                            menuPosition="fixed"
                                                                            {...field}
                                                                            options={dropDownValues?.phoneBrands}
                                                                            getOptionLabel={(option) => option.text}
                                                                        />
                                                                    )}
                                                                    control={control3}
                                                                    defaultValue=""
                                                                />
                                                                {errors3.phone_brand && (
                                                                    <p className="required">
                                                                        {errors3.phone_brand.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                            {personalFormData?.phone_brand?.some(a => a.value === "other") && <div class="input-label-wrap others-label">
                                                                <Controller
                                                                    refs={register2("other_phone_brand")}
                                                                    name="other_phone_brand"
                                                                    control={control3}
                                                                    render={({ field }) => (
                                                                        <MuiChipsInput
                                                                            autoComplete="off"
                                                                            renderChip={(Component, key, props) => {
                                                                                return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                            }}
                                                                            hideClearAll
                                                                            className="form-control"
                                                                            type="text"
                                                                            placeholder={getValuesThree("other_phone_brand")?.length === 0 || getValuesThree("other_phone_brand") === undefined ? "Other (Please Specify)" : false}
                                                                            addOnWhichKey={[",", "Enter"]}
                                                                            {...field}
                                                                        />
                                                                    )}
                                                                />
                                                            </div>}
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap">
                                                                <label htmlFor="">
                                                                    <img src={formIcon23} alt="" />️Preferred
                                                                    clothing style
                                                                </label>
                                                                <Controller
                                                                    name="preferred_clothings"
                                                                    refs={register3("preferred_clothings")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            placeholder={
                                                                                "Enter your Preferred Clothings"
                                                                            }
                                                                            menuPosition="fixed"
                                                                            {...field}
                                                                            options={dropDownValues?.clothingStyles}
                                                                            getOptionLabel={(option) => option.text}
                                                                            isMulti
                                                                            classNamePrefix="react-select"
                                                                            isClearable={false}
                                                                        />
                                                                    )}
                                                                    control={control3}
                                                                    defaultValue=""
                                                                />
                                                                {errors3.preferred_clothings && (
                                                                    <p className="required">
                                                                        {errors3.preferred_clothings.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap">
                                                                <label htmlFor="">
                                                                    <img src={formIcon24} alt="" />‍Mode of
                                                                    shooting videos
                                                                </label>
                                                                <Controller
                                                                    name="shooting_mode"
                                                                    refs={register3("shooting_mode")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            menuPosition="fixed"
                                                                            isClearable={false}
                                                                            {...field}
                                                                            options={
                                                                                dropDownValues?.videoShootingTypes
                                                                            }
                                                                            isMulti
                                                                            getOptionLabel={(option) => option.text}
                                                                            placeholder={"Enter Your Shooting Mode"}
                                                                        />
                                                                    )}
                                                                    control={control3}
                                                                    defaultValue=""
                                                                />
                                                                {errors3.shooting_mode && (
                                                                    <p className="required">
                                                                        {errors3.shooting_mode.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="input-label-wrap">
                                                                <label htmlFor="">
                                                                    <img src={formIcon25} alt="" />Food Preferences
                                                                </label>
                                                                <Controller
                                                                    name="food_preferences"
                                                                    refs={register3("food_preferences")}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            placeholder={
                                                                                "Enter your Food Preferences"
                                                                            }
                                                                            menuPosition="fixed"
                                                                            {...field}
                                                                            options={dropDownValues?.foodPreferences}
                                                                            getOptionLabel={(option) => option.text}
                                                                        />
                                                                    )}
                                                                    control={control3}
                                                                    defaultValue=""
                                                                />
                                                                {errors3.food_preferences && (
                                                                    <p className="required">
                                                                        {errors3.food_preferences.message}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                        </form>
                                    </>
                                </Tabs>
                            </div>
                        </div>
                        <div className="modal-footer">
                            {profileDetails.personal_detail ?
                                <div className="common-btn">
                                    {
                                        selectedTabs === 0 ? (
                                            <button
                                                form="formOne"
                                                type="submit"
                                                className="btn-garys"
                                                onClick={() => setSelectedTabs(1)}
                                            >
                                                Next
                                            </button>
                                        ) : selectedTabs === 1 ? <button
                                            form="formOne"
                                            type="submit"
                                            className="btn-garys"
                                            onClick={() => setSelectedTabs(2)}
                                        >
                                            Next
                                        </button> : null
                                    }
                                    <button
                                        form="formThree"
                                        type="submit"
                                        className="btn-green"
                                        onClick={() => setIsFormUpdate(true)}
                                    >
                                        Submit
                                    </button>
                                </div>
                                : <div className="common-btn">
                                    {selectedTabs === 0 ? (
                                        <button
                                            form="formOne"
                                            type="submit"
                                            className="btn-green"
                                            onClick={() => setSelectedTabs(1)}
                                        >
                                            Next
                                        </button>
                                    ) : selectedTabs === 1 ? (
                                        <button
                                            form="formTwo"
                                            type="submit"
                                            className="btn-green"
                                            onClick={() => setSelectedTabs(2)}
                                        >
                                            Next
                                        </button>
                                    ) : (
                                        <button
                                            form="formThree"
                                            type="submit"
                                            className="btn-green"
                                            onClick={() => setSubmitValueThree(true)}
                                        >
                                            Submit
                                        </button>
                                    )}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            {/* Creater New popup start here */}
            <div
                className="modal fade date-of-birth-wrap"
                id="open-date-picker"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            // data-backdrop="static"
            >
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <p>Date</p>{" "}
                            <p>{agePicker ? moment(agePicker).format("DD MMM YYYY") : ""}</p>
                        </div>
                        <div className="modal-body d-flex justify-content-center">
                            <div className="react-date-wrap">
                                <Calendar
                                    weekDays={weekDays}
                                    shadow={false}
                                    value={agePicker === "" ? moment().subtract(18, "years")._d : agePicker}
                                    onChange={(date) => {
                                        setAgePicker(new Date(date));
                                    }}
                                    maxDate={moment().subtract(18, "years")._d}
                                ></Calendar>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="common-btn">
                                <button type="button" onClick={onDatePick}>
                                    Done
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <div
                className="modal fade logout-popup-wrap save-store-popup"
                id="save-personal-details"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                data-backdrop="static"
                data-keyboard="false"
                aria-hidden="true"
            >
                <div
                    className="modal-dialog modal-dialog-centered custom-popup "
                    role="document"
                >
                    <div className="modal-content">
                        <div className="modal-body ">
                            <button
                                type="button"
                                data-dismiss="modal"
                                className="close save-close"
                            >
                                <span aria-hidden="true">
                                    <img src={Close_black} alt="" />
                                </span>
                            </button>
                            <div className="logout-card">
                                <h2>Save changes</h2>
                                <p>Do you want to save the changes you made?</p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="common-btn">
                                <button data-dismiss="modal" onClick={() => onSaveDetails()}>
                                    Save
                                </button>
                                <button data-dismiss="modal" onClick={() => {
                                    $("#creator-pop-new").modal("hide")
                                    resetTabs()
                                    setSelectedTabs(0)
                                }}  >Discard</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div > */}
        </>
    );
}

export default CreatorForm;